import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import { useDropzone } from 'react-dropzone';

import DeleteIcon from '@mui/icons-material/Delete';

import { Card, CardHeader, CardContent } from '@mui/material';
import { Box } from '@mui/material';


const DropZone = ({ files, onDrop, onDelete, label, buttonLabel }) => {

    const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone({
        // Disable click and keydown behavior
        noClick: true,
        noKeyboard: true,
        onDrop: (acceptedFiles) => { onDrop(acceptedFiles)}
    });

    const handleDelete = (id) => {
        onDelete(id)
    };

    return (
        <Card>

            <CardHeader title={label} titleTypographyProps={{ variant: "subtitle1" }} />
            <CardContent {...getRootProps({ className: 'dropzone' })}>

                <input {...getInputProps()} />

                <Box display="flex" alignItems="center">

                    <Box>
                        <Button onClick={open}>
                            {buttonLabel}
                        </Button>
                    </Box>

                    <Box>
                        <Typography>Ou déposer un fichier dans cette zone</Typography>
                    </Box>

                </Box>


                <div>
                    {files.map(f => (

                        
                        <Box key={f.name} display="flex" alignItems="center">
                            <Box>
                                <IconButton onClick={() => handleDelete(f.id)} size="large"><DeleteIcon fontSize="small" /></IconButton>
                            </Box>
                            <Box>
                                <Typography>{f.name}</Typography>
                            </Box>

                        </Box>
                    ))}
                </div>

            </CardContent>

        </Card>
    );


};

DropZone.propTypes = {
    files: PropTypes.array.isRequired,

    onDrop: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,

    label: PropTypes.string,
    buttonLabel: PropTypes.string
};

DropZone.defaultProps = {
    label: "Pièces jointes",
    buttonLabel: "Ajouter une pièce jointe"
};

export default DropZone;